.root {
  display: inline-grid;
  grid-template-columns: 0 auto;
}

.object {
  display: inline-grid;
  grid-template-rows: 0;
  align-items: center;
  align-self: center;
}

.aligner {
  visibility: hidden;
}
